/**
 * ブランド×カテゴリ別実績データ（デフォルト値）
 * キー: "{ブランド短縮キー}_{カテゴリ名}" 形式（detectBrandの返すキーに対応）
 * ソース: mall DB production 直近1年（レンタル10件以上、2026-03-31時点）
 *
 * @graph-stack mall-api
 * @graph-domain Operations
 * @graph-business モール本番実績データ。ブランド×カテゴリの購入転換率・レンタル件数・平均レンタル日数。81ライン
 * @graph-connects none
 */
export const DEFAULT_BRAND_LINES = {
    // ── 西川 ──
    '西川_マットレス・寝具': { rate: 18.5, rentals: 1386, avgDays: 51 },
    西川_リカバリーウェア: { rate: 23.5, rentals: 17, avgDays: 50 },
    // ── アテックス ──
    'アテックス_マッサージガン・マッサージ機': { rate: 25.0, rentals: 16, avgDays: 54 },
    // ── アンカー ──
    アンカー_プロジェクター: { rate: 8.3, rentals: 60, avgDays: 55 },
    'アンカー_掃除機・ロボット掃除機': { rate: 8.3, rentals: 12, avgDays: 47 },
    // ── エコバックス ──
    'エコバックス_掃除機・ロボット掃除機': { rate: 10.5, rentals: 19, avgDays: 94 },
    // ── エフェクティム ──
    'エフェクティム_美顔器・スチーマー': { rate: 4.2, rentals: 71, avgDays: 71 },
    // ── エプソン ──
    エプソン_プロジェクター: { rate: 14.3, rentals: 28, avgDays: 30 },
    // ── エレクトロン ──
    'エレクトロン_美顔器・スチーマー': { rate: 5.5, rentals: 487, avgDays: 56 },
    // ── エーグローバル ──
    'エーグローバル_美顔器・スチーマー': { rate: 3.3, rentals: 30, avgDays: 53 },
    // ── エーテルアース ──
    'エーテルアース_マッサージガン・マッサージ機': { rate: 57.1, rentals: 28, avgDays: 44 },
    // ── カドー ──
    'カドー_空気清浄機・加湿器・除湿器': { rate: 15.3, rentals: 340, avgDays: 68 },
    // ── ガーミン ──
    ガーミン_スマートウォッチ: { rate: 0.0, rentals: 26, avgDays: 40 },
    // ── キヌージョ ──
    キヌージョ_シャワーヘッド: { rate: 4.0, rentals: 25, avgDays: 52 },
    キヌージョ_ドライヤー: { rate: 12.7, rentals: 471, avgDays: 58 },
    キヌージョ_ヘアアイロン: { rate: 26.3, rentals: 864, avgDays: 61 },
    // ── クワッズ ──
    'クワッズ_生ごみ処理機・生ごみ乾燥機': { rate: 15.8, rentals: 19, avgDays: 67 },
    // ── サムソナイト ──
    サムソナイト_スーツケース: { rate: 1.3, rentals: 75, avgDays: 32 },
    // ── SIXPAD ──
    'SIXPAD_トレーニングマシン・器具': { rate: 12.1, rentals: 1790, avgDays: 102 },
    'SIXPAD_マッサージガン・マッサージ機': { rate: 41.7, rentals: 12, avgDays: 56 },
    SIXPAD_リカバリーウェア: { rate: 13.2, rentals: 53, avgDays: 53 },
    // ── シャーク ──
    'シャーク_掃除機・ロボット掃除機': { rate: 13.7, rentals: 51, avgDays: 55 },
    // ── シャープ ──
    シャープ_ドライヤー: { rate: 12.2, rentals: 49, avgDays: 47 },
    'シャープ_電気圧力鍋・自動調理鍋・鍋': { rate: 5.8, rentals: 86, avgDays: 49 },
    // ── シロカ ──
    シロカ_コーヒーメーカー: { rate: 0.0, rentals: 13, avgDays: 25 },
    'シロカ_食洗機・食器洗い乾燥機': { rate: 0.0, rentals: 12, avgDays: 40 },
    // ── スイッチボット ──
    'スイッチボット_掃除機・ロボット掃除機': { rate: 5.3, rentals: 19, avgDays: 31 },
    // ── ステラボーテ ──
    'ステラボーテ_美顔器・スチーマー': { rate: 13.7, rentals: 249, avgDays: 70 },
    'ステラボーテ_脱毛器・光美容器': { rate: 17.3, rentals: 81, avgDays: 110 },
    // ── ソニー ──
    'ソニー_イヤホン・ヘッドホン': { rate: 10.0, rentals: 10, avgDays: 80 },
    'ソニー_カメラ・アクションカメラ': { rate: 0.0, rentals: 12, avgDays: 9 },
    // ── ソノリプロ ──
    ソノリプロ_ヘッドスパ: { rate: 41.9, rentals: 43, avgDays: 134 },
    // ── ソーダストリーム ──
    ソーダストリーム_炭酸水メーカー: { rate: 12.5, rentals: 40, avgDays: 56 },
    // ── ダイソン ──
    ダイソン_ドライヤー: { rate: 7.7, rentals: 39, avgDays: 61 },
    ダイソン_ヘアアイロン: { rate: 4.3, rentals: 94, avgDays: 56 },
    'ダイソン_掃除機・ロボット掃除機': { rate: 5.0, rentals: 40, avgDays: 58 },
    'ダイソン_空気清浄機・加湿器・除湿器': { rate: 10.7, rentals: 28, avgDays: 64 },
    // ── ディズム ──
    'ディズム_美顔器・スチーマー': { rate: 3.1, rentals: 32, avgDays: 62 },
    // ── バルミューダ ──
    バルミューダ_オーブントースター: { rate: 30.0, rentals: 10, avgDays: 66 },
    バルミューダ_スピーカー: { rate: 30.0, rentals: 10, avgDays: 56 },
    'バルミューダ_空気清浄機・加湿器・除湿器': { rate: 0.0, rentals: 13, avgDays: 62 },
    // ── パナソニック ──
    パナソニック_シャワーヘッド: { rate: 36.3, rentals: 179, avgDays: 46 },
    パナソニック_ドライヤー: { rate: 20.2, rentals: 667, avgDays: 54 },
    パナソニック_ヘアアイロン: { rate: 22.6, rentals: 186, avgDays: 59 },
    'パナソニック_マッサージガン・マッサージ機': { rate: 25.5, rentals: 685, avgDays: 61 },
    'パナソニック_美顔器・スチーマー': { rate: 14.8, rentals: 1630, avgDays: 80 },
    'パナソニック_脱毛器・光美容器': { rate: 17.3, rentals: 248, avgDays: 97 },
    // ── ビクセン ──
    'ビクセン_双眼鏡・距離計': { rate: 10.8, rentals: 120, avgDays: 36 },
    // ── ビサラ ──
    ビサラ_ドライヤー: { rate: 32.6, rentals: 46, avgDays: 51 },
    // ── ブライト ──
    ブライト_ドライヤー: { rate: 14.6, rentals: 171, avgDays: 43 },
    'ブライト_美顔器・スチーマー': { rate: 6.1, rentals: 543, avgDays: 57 },
    // ── ブレインスリープ ──
    'ブレインスリープ_マットレス・寝具': { rate: 12.2, rentals: 196, avgDays: 45 },
    ブレインスリープ_リカバリーウェア: { rate: 27.3, rentals: 22, avgDays: 63 },
    // ── ベネクス ──
    ベネクス_リカバリーウェア: { rate: 27.2, rentals: 103, avgDays: 65 },
    // ── ベレガ ──
    'ベレガ_美顔器・スチーマー': { rate: 12.5, rentals: 1269, avgDays: 79 },
    // ── ボリーナ ──
    ボリーナ_シャワーヘッド: { rate: 21.8, rentals: 55, avgDays: 45 },
    // ── ボーズ ──
    ボーズ_スピーカー: { rate: 0.0, rentals: 10, avgDays: 91 },
    // ── マイトレックス ──
    マイトレックス_シャワーヘッド: { rate: 20.9, rentals: 254, avgDays: 57 },
    'マイトレックス_トレーニングマシン・器具': { rate: 18.0, rentals: 150, avgDays: 87 },
    'マイトレックス_マッサージガン・マッサージ機': { rate: 18.9, rentals: 461, avgDays: 70 },
    'マイトレックス_美顔器・スチーマー': { rate: 13.0, rentals: 437, avgDays: 78 },
    'マイトレックス_脱毛器・光美容器': { rate: 16.1, rentals: 31, avgDays: 102 },
    // ── マーシャル ──
    マーシャル_スピーカー: { rate: 17.1, rentals: 35, avgDays: 49 },
    // ── ミラブル ──
    ミラブル_シャワーヘッド: { rate: 18.1, rentals: 586, avgDays: 49 },
    // ── ミーゼ ──
    'ミーゼ_トレーニングマシン・器具': { rate: 20.0, rentals: 15, avgDays: 97 },
    ミーゼ_ヘッドスパ: { rate: 13.8, rentals: 65, avgDays: 58 },
    'ミーゼ_美顔器・スチーマー': { rate: 10.0, rentals: 40, avgDays: 51 },
    // ── ヤーマン ──
    ヤーマン_ドライヤー: { rate: 13.2, rentals: 38, avgDays: 70 },
    ヤーマン_ヘアアイロン: { rate: 15.7, rentals: 281, avgDays: 58 },
    'ヤーマン_美顔器・スチーマー': { rate: 9.8, rentals: 1445, avgDays: 75 },
    'ヤーマン_脱毛器・光美容器': { rate: 5.4, rentals: 129, avgDays: 95 },
    // ── ラディアント ──
    ラディアント_ヘアアイロン: { rate: 6.3, rentals: 16, avgDays: 27 },
    // ── リアズ ──
    リアズ_ペット用品: { rate: 30.0, rentals: 40, avgDays: 79 },
    // ── リコー ──
    'リコー_カメラ・アクションカメラ': { rate: 9.1, rentals: 11, avgDays: 6 },
    // ── リファ ──
    リファ_シャワーヘッド: { rate: 34.4, rentals: 1357, avgDays: 65 },
    リファ_ドライヤー: { rate: 21.6, rentals: 1034, avgDays: 66 },
    リファ_ヘアアイロン: { rate: 23.0, rentals: 993, avgDays: 65 },
    リファ_ヘッドスパ: { rate: 9.1, rentals: 110, avgDays: 57 },
    'リファ_美顔器・スチーマー': { rate: 6.7, rentals: 15, avgDays: 69 },
    'リファ_脱毛器・光美容器': { rate: 20.8, rentals: 96, avgDays: 115 },
    // ── ルーヴルドー ──
    ルーヴルドー_ドライヤー: { rate: 13.8, rentals: 29, avgDays: 35 },
};
//# sourceMappingURL=brand-lines.js.map